/// <reference path="../../../tools/typings/tsd.d.ts"/>
/// <reference path="../services.ts"/>

namespace DealerwareWebServices
{
    "use strict";

    export class DealerwareEmployeeStatesData {

        public states: any = {

            all: [ ]
        }
    }

    getDealerwareWebServicesModule().service(
        '$dealerwareEmployeeStatesData', DealerwareEmployeeStatesData
    );
}